// extracted by mini-css-extract-plugin
export var emptyState = "_5v-d";
export var statCard = "_5v-c";
export var table = "_5v-0";
export var tableCell = "_5v-4";
export var tableCellClickable = "_5v-5 _5v-4";
export var tableCellDefault = "_5v-6 _5v-4";
export var tableCellEmpty = "_5v-8";
export var tableCellWithValue = "_5v-7";
export var tableContainer = "_5v-e";
export var tableHeaderWeight = "_5v-1";
export var tableHeaderZone = "_5v-2";
export var tableRowHeader = "_5v-3";
export var viewModeButton = "_5v-9";
export var viewModeButtonActive = "_5v-a _5v-9";
export var viewModeButtonInactive = "_5v-b _5v-9";